import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, vModelText as _vModelText, withKeys as _withKeys, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '../../static/icons/cancel_black_icon.svg'
import _imports_1 from '../../static/icons/search-icon.svg'


const _hoisted_1 = { class: "search-view-input" }
const _hoisted_2 = ["placeholder", "onKeyup"]

import { onBeforeUnmount, onMounted, ref, watch } from 'vue';

import useScrollIntent from '@/composables/useScrollIntent';
import useContext from '@/composables/useContext';
import useWebsiteTexts from '@/composables/useWebsiteTexts';
import { getSearchContext } from '@/composables/useSearch';

export default /*#__PURE__*/_defineComponent({
  __name: 'SearchViewInput',
  props: {
  focus: {
    type: Boolean,
    default: false,
  },
},
  setup(__props) {

const props = __props;

const { performFullSearch } = getSearchContext()


const { route, mitt } = useContext();
const { websiteText } = useWebsiteTexts();

const searchInput = ref<HTMLInputElement | null>(null);

const isScrolled = ref(false);
const searchStringModel = ref('');
const searchTimeout = ref<number | null>(null);

useScrollIntent(isScrolled);

watch(searchStringModel, (newValue) => {
  if (searchTimeout.value) {
    clearTimeout(searchTimeout.value);
  }
  searchTimeout.value = setTimeout(() => {
    mitt.emit('perform-quick-search', newValue);
  }, 300);
});

watch(
  route,
  () => {
    searchStringModel.value = '';
  },
  { deep: true }
);

onMounted(() => {
  if (props.focus) {
    focusSearchInput();
  }

  mitt.on('focus-search-input', focusSearchInput);
  mitt.on('clear-search-input', clearSearchInput);
});

onBeforeUnmount(() => {
  mitt.off('focus-search-input', focusSearchInput);
  mitt.off('clear-search-input', clearSearchInput);
});

function selectText() {
  if (searchInput.value) {
    searchInput.value.select();
  }
}

function cancelSearch() {
  searchStringModel.value = '';
  searchInput.value?.focus();
}

function triggerFullSearch() {
  if (!searchStringModel.value) return;
  mitt.emit('perform-full-search', searchStringModel.value);
}

function onEnterKeyPressed() {
  searchInput.value?.blur();
  performFullSearch();
}

function clearSearchInput() {
  searchStringModel.value = '';
}

function focusSearchInput() {
  searchInput.value?.focus();
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives(_createElementVNode("input", {
      type: "text",
      class: _normalizeClass(["search-view-input__input", { 'search-view-input__input--scrolled': isScrolled.value }]),
      ref_key: "searchInput",
      ref: searchInput,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((searchStringModel).value = $event)),
      placeholder: _unref(websiteText)('search__placeholder').value,
      onFocus: _cache[1] || (_cache[1] = ($event: any) => (selectText())),
      onBlur: _cache[2] || (_cache[2] = ($event: any) => (_unref(mitt).emit('search-performed'))),
      onKeyup: _withKeys(onEnterKeyPressed, ["enter"])
    }, null, 42, _hoisted_2), [
      [_vModelText, searchStringModel.value]
    ]),
    _createElementVNode("div", {
      class: _normalizeClass(["search-view-input__search-input-icon-wrapper", {
        'search-view-input__search-input-icon-wrapper--toggled':
          searchStringModel.value,
      }])
    }, [
      (searchStringModel.value)
        ? (_openBlock(), _createElementBlock("img", {
            key: 0,
            class: "search-view-input__delete-icon",
            src: _imports_0,
            onClick: _cache[3] || (_cache[3] = ($event: any) => (cancelSearch()))
          }))
        : _createCommentVNode("", true),
      _createElementVNode("img", {
        class: "search-view-input__search-input-icon",
        src: _imports_1,
        onClick: _cache[4] || (_cache[4] = ($event: any) => (_unref(performFullSearch)()))
      })
    ], 2)
  ]))
}
}

})